import { del, get, post, put } from "../util/http.service";

export const apiGetVehicules = params => ({
  queryKey: ["vehicules", params],
  queryFn: () => get("/api/vehicules", params)
});

export const apiCreateVehicule = () => ({
  mutationFn: data => post("/api/vehicules", data)
});

export const apiUpdateVehicule = id => ({
  mutationFn: data => put("/api/vehicules/" + id, data)
});

export const apiDeleteVehicule = () => ({
  mutationFn: data => del("/api/vehicules/" + data.id)
});

export const apiCreateVehiculeFile = () => ({
  mutationFn: data => post("/api/vehicules/" + data.vehiculeId + "/files", data.data)
});

export const apiDeleteVehiculeFile = () => ({
  mutationFn: data => del("/api/vehicules/" + data.vehiculeId + "/files/" + data.fileId)
});
